export const DEFAULT_LIMIT: Readonly<number> = 10;
